var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('Title', {
    attrs: {
      "text-start": "",
      "font-weight": 600,
      "font-size": 14,
      "title": "Документ об образовании",
      "append-icon": "mdi-trash-can-outline"
    },
    on: {
      "click:append-outer": _vm.removeEducation
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.educationDocType,
      "item-text": "name",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "placeholder": "Выберите из списка",
      "no-data-text": "Не найдено",
      "return-object": ""
    },
    on: {
      "input": _vm.setEducation
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Тип документа")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.education.educationDocType,
      callback: function callback($$v) {
        _vm.$set(_vm.education, "educationDocType", $$v);
      },
      expression: "education.educationDocType"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "rounded": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": _vm.setEducation
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Серия")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.education.series,
      callback: function callback($$v) {
        _vm.$set(_vm.education, "series", $$v);
      },
      expression: "education.series"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "rounded": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": _vm.setEducation
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Номер")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.education.number,
      callback: function callback($$v) {
        _vm.$set(_vm.education, "number", $$v);
      },
      expression: "education.number"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('DatePicker', {
    attrs: {
      "label": "Дата выдачи",
      "required": "",
      "prop-date": _vm.education.issueDate
    },
    on: {
      "set-date": _vm.setIssueDate
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('FileInput', {
    attrs: {
      "title": "Файл документа об образовании",
      "ref-id": _vm.education.id,
      "ref-class-name": "Education"
    },
    on: {
      "set-files": _vm.setFiles
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }